import { MenuItem, styled, TextField } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectPrompts, setSortDirection, setSortOption } from '../../redux/reducers/promptReducer';
import { AppDispatch } from '../../redux/store';
import { PromptSortOptions, SortDirection } from '../../Types/enums';

interface PromptSortDropdownProps {
  sortOption: string;
  sortDirection: string | null;
}

const SortDropdownContainer = styled('div')(() => {
  return {
    display: 'flex',
    gap: '15px',
    width: '100%',
  };
});

const sortOptions = [
  { label: 'Default', value: PromptSortOptions.DEFAULT },
  { label: 'Likes', value: PromptSortOptions.LIKES },
  { label: 'Usage', value: PromptSortOptions.USAGE },
  { label: 'Modified At', value: PromptSortOptions.UPDATEDAT },
  { label: 'Created At', value: PromptSortOptions.CREATEDAT },
];

const sortNumericDirections = [
  { label: 'High to Low', value: SortDirection.DESC },
  { label: 'Low to High', value: SortDirection.ASC },
];

const sortDateDirections = [
  { label: 'Newest to Oldest', value: SortDirection.DESC },
  { label: 'Oldest to Newest', value: SortDirection.ASC },
];

const sortDirectionMap: Record<PromptSortOptions, { label: string; value: SortDirection }[]> = {
  [PromptSortOptions.DEFAULT]: sortNumericDirections,
  [PromptSortOptions.LIKES]: sortNumericDirections,
  [PromptSortOptions.USAGE]: sortNumericDirections,
  [PromptSortOptions.UPDATEDAT]: sortDateDirections,
  [PromptSortOptions.CREATEDAT]: sortDateDirections,
};

const PromptSortDropdown: React.FC<PromptSortDropdownProps> = ({ sortOption, sortDirection }) => {
  const dispatch = useDispatch<AppDispatch>();

  const { totalCount: promptsCount } = useSelector(selectPrompts);

  const handleSortChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setSortOption(e.target.value as PromptSortOptions));

    if (e.target.value === PromptSortOptions.DEFAULT) {
      dispatch(setSortDirection(SortDirection.DESC));
    }
    if (!sortDirection && e.target.value !== PromptSortOptions.DEFAULT) {
      dispatch(setSortDirection(SortDirection.DESC));
    }
  };

  const handleSortDirectionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setSortDirection(e.target.value as SortDirection));
  };

  return (
    <SortDropdownContainer>
      <TextField
        sx={{ width: '50%' }}
        value={sortOption}
        onChange={handleSortChange}
        label={'Sort'}
        select
        disabled={promptsCount === 0}
      >
        {sortOptions.map((option) => (
          <MenuItem value={option.value} key={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        value={sortDirection || ''}
        onChange={handleSortDirectionChange}
        label={'Sort Direction'}
        disabled={sortOption === PromptSortOptions.DEFAULT || promptsCount === 0}
        select
        sx={{ width: '50%' }}
      >
        {sortDirectionMap[sortOption as PromptSortOptions].map((option) => (
          <MenuItem value={option.value} key={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    </SortDropdownContainer>
  );
};

export default PromptSortDropdown;
